/**
 * sessionStorage key used to stash the attempted `?coupon=` deep-link
 * (e.g. "/pricing?coupon=LINGUIX50", the FlyGrammar offer link) when
 * AuthGuardService bounces a logged-out user to /session/signin.
 * AuthGuardService's redirect is a hard page navigation
 * (window.open(..., "_self")), which wipes AuthService's in-memory
 * redirectUrl, so the pending destination has to survive in sessionStorage
 * instead — same pattern as CAMPAIGN_REDIRECT_STORAGE_KEY (issue #592).
 * Consumed once (read + cleared) by AuthService after login or registration
 * completes.
 */
export const COUPON_REDIRECT_STORAGE_KEY = "coupon_redirect_url";
